import { action, makeObservable } from 'mobx'
import moment from 'moment'
import FormStore from '../../../utils/stores/FormStore'

const initState = {
  reportMonth: moment().format('MM'),
  reportYear: moment().format('YYYY'),
}

const validateData = {
  dealer: { required: true },
}

class DataSettingsFilterStore extends FormStore {
  constructor() {
    super({ initState, validateData })
    makeObservable(this, {
      initStateSet: action,
    })
  }

  initStateSet = () => {
    this.setData({
      reportMonth: moment().format('MM'),
      reportYear: moment().format('YYYY'),
    })
  }

  clear = () => {
    this.setData({
      dealer: '',
      reportMonth: '',
      reportYear: '',
    })
    this.clearSelectedFilters()
  }
}

export default DataSettingsFilterStore
